import { render } from "./TheHeader.vue?vue&type=template&id=b899246e&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=b899246e&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b899246e"]])

export default __exports__